'use client';
import React, { useState, useEffect } from 'react';
import AppSidebar from './AppSidebar';
import AppTopbar from './AppTopbar';
import MarketingFooter from './MarketingFooter';
import OnboardingTour from './OnboardingTour';
import OnboardingChecklist from './OnboardingChecklist';
import FloatingActionStack from './FloatingActionStack';
import DreamTwinSyncBridge from './DreamTwinSyncBridge';

interface AppLayoutProps {
  children: React.ReactNode;
  title?: string;
}

export default function AppLayout({ children, title }: AppLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile sidebar overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 lg:hidden"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed left-0 top-0 bottom-0 z-40
        transition-transform duration-300
        ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0
      `}>
        <AppSidebar collapsed={collapsed} onCollapse={setCollapsed} />
      </div>

      <AppTopbar
        sidebarCollapsed={collapsed}
        title={title}
        onMobileMenuToggle={() => setMobileOpen(prev => !prev)}
      />

      <main
        className={`transition-all duration-300 pt-16 min-h-screen flex flex-col
          ${collapsed ? 'lg:ml-16' : 'lg:ml-64'}
          ml-0
        `}
      >
        <div className="flex-1 px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 py-5 sm:py-6 max-w-screen-2xl mx-auto w-full page-fade-in">
          {children}
        </div>
        <MarketingFooter />
      </main>

      <OnboardingTour />
      <OnboardingChecklist />
      <FloatingActionStack />
      <DreamTwinSyncBridge />
    </div>
  );
}